(() => {
  const SELECTOR = "[data-lazy-app]";

  const isJsonScript = (script) => {
    const type = (script.getAttribute("type") || "").toLowerCase();
    return type === "application/ld+json" || type === "application/json";
  };

  const runScripts = (root) => {
    const scripts = root.querySelectorAll("script");
    scripts.forEach((oldScript) => {
      if (isJsonScript(oldScript)) return;

      const s = document.createElement("script");
      // Copy attributes (src, type, async, defer, etc.)
      for (const { name, value } of Array.from(oldScript.attributes)) {
        s.setAttribute(name, value);
      }
      s.text = oldScript.text || "";
      oldScript.replaceWith(s);
    });
  };

  const hydrate = (wrap) => {
    if (!wrap || wrap.dataset.hydrated === "true") return;

    const tpl = wrap.querySelector("template.sc-lazy-app__tpl");
    if (!tpl) return;

    const frag = tpl.content.cloneNode(true);
    wrap.replaceChildren(frag);
    runScripts(wrap);
    wrap.dataset.hydrated = "true";
  };

  const init = () => {
    const nodes = Array.from(document.querySelectorAll(SELECTOR));
    if (nodes.length === 0) return;

    // Low-risk defaults: load when close to viewport, keep main thread light.
    const io =
      "IntersectionObserver" in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (!e.isIntersecting) return;
                hydrate(e.target);
                io.unobserve(e.target);
              });
            },
            { root: null, rootMargin: "600px 0px", threshold: 0.01 }
          )
        : null;

    nodes.forEach((n) => {
      if (io) io.observe(n);
      else hydrate(n);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
